import { useMediaQuery } from "@mui/material";

const useGenericHook = () => {

    const isScreenBelow1600 = useMediaQuery('(min-width: 0px) and (max-width : 1600px)');
    const isScreenBelow1250 = useMediaQuery("(min-width: 0px) and (max-width: 1250px)");
    const isScreenBelow1000 = useMediaQuery("(min-width: 0px) and (max-width: 1000px)");
    const isScreenBelow600 = useMediaQuery("(min-width: 0px) and (max-width: 600px)");
    const isScreenBelow768 = useMediaQuery("(min-width: 0px) and (max-width: 768px)");

    return {
        isScreenBelow1600,
        isScreenBelow1250,
        isScreenBelow1000,
        isScreenBelow600,
        isScreenBelow768
    };
}

export default useGenericHook;